// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".allthings-module--layout {\n  padding: 30px 0 0 0; }\n  .allthings-module--layout .allthings-module--container-cards {\n    display: grid;\n    grid-template-columns: repeat(auto-fill, minmax(380px, 1fr));\n    gap: 20px; }\n  .allthings-module--layout .content-courses {\n    display: flex;\n    flex-direction: row;\n    flex-flow: row wrap;\n    justify-content: flex-start;\n    align-items: flex-start;\n    gap: 23px;\n    margin-top: 25px; }\n", ""]);
// Exports
module.exports = exports;
